import React from 'react';
import styles from './Loader.module.css';

export default function Loader() {
  return <span className={styles.loader}></span>;
}
